module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.label != '') ? _c('div', {
    staticClass: "form-item",
    class: [
      'form-item-' + this.theme
    ],
    on: {
      "click": _vm.handleClick
    }
  }, [_c('label', {
    class: ['label-' + this.size],
    attrs: {
      "for": _vm.name
    }
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    class: [
      'be-' + _vm.stateSelf,
      _vm.icon != '' ? 'has-icon' : ''
    ]
  }, [(_vm.type == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueSelf),
      expression: "valueSelf"
    }],
    ref: "input",
    staticClass: "input form-control",
    class: [
      'input-' + this.size,
      'input-' + this.theme
    ],
    attrs: {
      "type": "text",
      "name": _vm.name,
      "placeholder": _vm.holder,
      "disabled": !_vm.enable
    },
    domProps: {
      "value": (_vm.valueSelf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueSelf = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueSelf),
      expression: "valueSelf"
    }],
    ref: "input",
    staticClass: "input form-control",
    class: [
      'input-' + this.size,
      'input-' + this.theme
    ],
    attrs: {
      "type": "password",
      "name": _vm.name,
      "placeholder": _vm.holder,
      "disabled": !_vm.enable
    },
    domProps: {
      "value": (_vm.valueSelf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueSelf = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
    staticClass: "icon iconfont",
    class: ['icon-' + _vm.icon]
  }) : _vm._e()])]) : _c('div', {
    staticClass: "form-item",
    class: [
      'be-' + _vm.stateSelf,
      _vm.icon != '' ? 'has-icon' : ''
    ],
    on: {
      "click": _vm.handleClick
    }
  }, [(_vm.type == 'text') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueSelf),
      expression: "valueSelf"
    }],
    ref: "input",
    staticClass: "input form-control",
    class: [
      'input-' + this.size,
      this.theme == 'underline' ? 'input-' + this.theme : ''
    ],
    attrs: {
      "type": "text",
      "name": _vm.name,
      "placeholder": _vm.holder,
      "disabled": !_vm.enable
    },
    domProps: {
      "value": (_vm.valueSelf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueSelf = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 'password') ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.valueSelf),
      expression: "valueSelf"
    }],
    ref: "input",
    staticClass: "input form-control",
    class: [
      'input-' + this.size,
      this.theme == 'underline' ? 'input-' + this.theme : ''
    ],
    attrs: {
      "type": "password",
      "name": _vm.name,
      "placeholder": _vm.holder,
      "disabled": !_vm.enable
    },
    domProps: {
      "value": (_vm.valueSelf)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.valueSelf = $event.target.value
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.icon != '') ? _c('i', {
    staticClass: "icon iconfont",
    class: ['icon-' + _vm.icon]
  }) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-10ce8fb5!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/bo-input/bo-input.vue
// module id = 11
// module chunks = 0 1 2 3 5